import React, { useState } from 'react';
import { loadModules } from "esri-loader";


export function loadMap(container, basemap) {
  return loadModules(
    ["esri/views/SceneView",
      "esri/WebScene",
      "esri/Map",
      "esri/layers/GraphicsLayer",
      "esri/widgets/Sketch/SketchViewModel"],
    // this stylesheet is only loaded once
    { css: "https://js.arcgis.com/4.10/esri/css/main.css" }
  ).then(([SceneView, WebScene, Map, GraphicsLayer, SketchViewModel]) => {

  
    const webScene = new WebScene({
      portalItem: {
        // autocasts as new PortalItem()
        // id: "414a28cfca7a471180e8e952cf14c60f"
        // id: "8a2cbd5b4f994aa6821e3d374410f784"
        id:"2fde2b517d094ef3bf84fd4cabedeef4"
      }
    });

    const map = new Map({ basemap: 'osm' });
    
    const view = new SceneView({
      container,
      map: webScene
    });

    const graphicsLayer = new GraphicsLayer({
      elevationInfo: { mode: "on-the-ground" }
    });

    view.map.add(graphicsLayer);

    const tentBtn = document.getElementById("tent");
    const canoeBtn = document.getElementById("canoe");
    const opacityInput = document.getElementById("opacityInput");

    view.when(() => {

      // This sample uses the SketchViewModel to add points to a
      // GraphicsLayer. The points have 3D glTF models as symbols.
      const sketchVM = new SketchViewModel({
        layer: graphicsLayer,
        view: view
      });

      tentBtn.addEventListener("click", () => {
        // reference the relative path to the glTF model
        // in the resource of an ObjectSymbol3DLayer
        sketchVM.pointSymbol = {
          type: "point-3d",
          symbolLayers: [
            {
              type: "object",
              resource: {
                href: "/assets/stationEncloded2.glb"
              }
            }
          ]
        };
        sketchVM.create("point");
        deactivateButtons();
        this.classList.add("esri-button--secondary");
      });

      canoeBtn.addEventListener("click", () => {
        // reference the relative path to the glTF model
        // in the resource of an ObjectSymbol3DLayer
        sketchVM.pointSymbol = {
          type: "point-3d",
          symbolLayers: [
            {
              type: "object",
              resource: {
                href: "https://sdsic-images.s3.amazonaws.com/Gltfs/DigitalTwinStation1.glb"
              }
            }
          ]
        };
        deactivateButtons();
        sketchVM.create("point");
        this.classList.add("esri-button--secondary");
      });

      sketchVM.on("create", (event) => {
        if (event.state === "complete") {
          sketchVM.update(event.graphic);
          deactivateButtons();
        }
      });

    })
      .catch(console.error);

    function deactivateButtons() {
      const elements = Array.prototype.slice.call(document.getElementsByClassName("esri-button"));
      elements.forEach((element) => {
        element.classList.remove("esri-button--secondary");
      });
    }

    // the webscene has no basemap, so set a surfaceColor on the ground
      // map.ground.surfaceColor = "#fff";
      // to see through the ground, set the ground opacity to 0.4
      map.ground.opacity = 1;
      map.ground.navigationConstraint = {
        type: "stayAbove"
      }

      opacityInput.addEventListener("change", (event) => {
        
        if (event.target.checked === true) {
          map.ground.opacity = 0.8;
          
          map.ground.navigationConstraint = {
            type: "none"
          }
        } else {
          
          map.ground.opacity = 1;
          map.ground.navigationConstraint = {
            type: "stayAbove"
          }
        }
        
      });


    view.ui.add(document.getElementById('paneDiv'), "top-right");
 
  return view;
});
}
